import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {DataStorageService} from '../../../data-storage.service';
import {AvailableComponents} from '../../../side-bar/enumAvailableComponents';
import {PPhostedPricing} from '../../../../models/PPhostedPricing.model';
import {ApiService} from '../../../api.service';
import {PricingService} from '../../../pricing.service';
import {SecurityService} from '../../../security.service';
import {ApiTextService} from '../../../apiServices/text/text.service';
import {preserveWhitespacesDefault} from '@angular/compiler';
import {ThreeCXPricing} from '../../../../models/ThreeCXPricing';
import {log} from 'util';
import {distinct} from 'rxjs/operator/distinct';
import {add} from 'ngx-bootstrap/chronos';

@Component({
  selector: 'app-three-cx',
  templateUrl: './threeCX.component.html',
  styleUrls: ['./threeCX.component.scss']
})
export class ThreeCXComponent implements OnInit, OnDestroy, AfterViewInit {

  pricingList: ThreeCXPricing[];
  types: String[];
  terms: number[];
  scs: number[];
  addons: String[];

  constructor(
    public dataStorageService: DataStorageService,
    public securityService: SecurityService,
    private tApi: ApiTextService,
    private api: ApiService,
    private pricing: PricingService) {
    this.pricingList = [];

    pricing.get3CXPriceList().then(data => {
      this.pricingList = data;
      this.types = this.getTypes();
      this.terms = this.getTerms();
      this.scs = this.getSCs();
      this.addons = this.getAddons();
      this.addons.push('None');
      this.getValue().then((offer) => {
        if (dataStorageService.currentState.threeCX.costMonthlySub === 0) {
          this.updateMonthlyCosts();
        }
      });
    });
  }

  ngAfterViewInit(): void {
    if (this.dataStorageService.currentState.threeCX.sc === -1) {
      document.getElementById('3cxSCSelect').setAttribute('value', '');
    }
  }

  ngOnInit() {
    const element = document.getElementById('pfThreeCX');
    element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents['ThreeCX'];
  }

  ngOnDestroy() {
    const element = document.getElementById('pfThreeCX');
    element.classList.remove('active');
  }

  setValue(event: any, field: string, value) {
    const data = this.dataStorageService.currentState.threeCX;
    switch (field) {
      case 'type':
        this.dataStorageService.currentState.threeCX.type = value;
        if ((value === 'Professional' || value === 'Standard' || value === 'Enterprise' || value === 'Unlicensed')) {
          this.dataStorageService.currentState.threeCX.term = this.terms[0];
          this.dataStorageService.currentState.threeCX.sc = this.filterSC(value)[0];
        }
        break;
      case 'term':
        this.dataStorageService.currentState.threeCX.term = Number(value);
        break;
      case 'sc':
        this.dataStorageService.currentState.threeCX.sc = Number(value);
        break;
      case 'addon':
        this.dataStorageService.currentState.threeCX.addon = value;
        break;
    }

    this.updateMonthlyCosts();
  }

  getTypes() {
    return Array.from(new Set(this.pricingList.map(x => x.type))).filter(function (value, index, array) {
      return !(value.includes('Extension') || value.includes('None'));
    }).sort((a, b) => {
      switch (a){
        case 'Standard':
          return -1;
        case 'Professional':
          if(b !== 'Standard') {
            return -1;
          }
          return 1;
        case 'Enterprise':
          if(b !== 'Unlicensed') {
            return 1;
          }
          return -1;
        case 'Unlicensed':
          return 1;
        default:
          return 0;
      }
    });
  }

  getTerms() {
    return Array.from(new Set(this.pricingList.map(x => x.term))).filter(function (value, index, array) {
      return value !== -1;
    });
  }

  getSCs() {
    return Array.from(new Set(this.pricingList.map(x => x.sc))).filter(function (value, index, array) {
      return value !== -1;
    });
  }

  getAddons() {
    return Array.from(new Set(this.pricingList.map(x => x.type))).filter(function (value, index, array) {
      return value.includes('Extension');
    });
  }


  putValue() {
    return this.api.putThreeCX(this.dataStorageService.currentState.offerID);
  }



  getValue() {
    return this.api.getThreeCX(this.dataStorageService.currentState.offerID);
  }

  getSubscriptionPricing(type: String, term: number, sc: number): ThreeCXPricing {
    return this.pricingList.find(e => e.type === type && e.term === term && e.sc === sc);
  }

  getSubscriptionCosts() {
    return this.dataStorageService.currentState.threeCX.costMonthlySub;
  }

  getAddonCosts() {
    return this.dataStorageService.currentState.threeCX.costMonthlyAddon;
  }

  getTotalCosts() {
    return this.dataStorageService.currentState.threeCX.costMonthlySub + this.dataStorageService.currentState.threeCX.costMonthlyAddon;
  }

  getOnRequest() {
    return this.dataStorageService.currentState.threeCX.costMonthlySubEditable;
  }

  filterSC(type: string) {
    const filtered = this.pricingList.filter((e) => {
      return e.type === type;
    });
    const toReturn = new Set();
    filtered.map(e => {
      toReturn.add(e.sc);
    });
    return Array.from(toReturn).sort(function(a, b) {
      return a - b;
    });
  }

  updateMonthlyCosts() {
    const data = this.dataStorageService.currentState.threeCX;
    const subscriptionPricing = this.getSubscriptionPricing(data.type, data.term, data.sc);
    const addonPricing = this.getSubscriptionPricing(data.addon, -1, -1);
    data.costMonthlyAddon = addonPricing.costMonthly;
    data.costMonthlySub = subscriptionPricing.costMonthly;
    data.costMonthlySubEditable = subscriptionPricing.costMonthlyEditable;
    this.putValue();
  }

  cancelClick() {
    this.dataStorageService.currentState.threeCX.type = 'Standard';
    this.dataStorageService.currentState.threeCX.term = 12;
    this.dataStorageService.currentState.threeCX.sc = 4;
    this.dataStorageService.currentState.threeCX.addon = null;
    this.putValue();
  }

  logData() {
    console.log(this.dataStorageService.currentState.threeCX);
    console.log(this.dataStorageService.threeCXPricing);
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/threeCX/threeCX.component.ts